import {createSlice} from "@reduxjs/toolkit";
import {institutionSearchSlice} from "../medical_institution/search";

const initialState = {
  page: 1,
  limit: 10,
  search: {
    prefecture_id: null,
    address: null,
    facility: null
  }
}

export const searchAgenciesSlice = createSlice({
  name: 'searchAgencies',
  initialState,
  reducers: {
    setPage: (state, action) => {
      return {
        ...state,
        page: action.payload
      }
    },
    setPrefecture: (state, action) => {
      return {
        ...state,
        search: {
          ...state.search,
          prefecture_id: action.payload
        }
      }
    },
    setAddress: (state, action) => {
      return {
        ...state,
        search: {
          ...state.search,
          address: action.payload
        }
      }
    },
    setFacility: (state, action) => {
      return {
        ...state,
        search: {
          ...state.search,
          facility: action.payload
        }
      }
    },
    resetAgencies: (state) => {
      return {
        ...state,
        search: initialState.search
      }
    }
  }
})
export const { setPage, setPrefecture, setAddress, setFacility, resetAgencies } = searchAgenciesSlice.actions

export default searchAgenciesSlice.reducer